import { useState } from 'react';
import { TableRow, Checkbox, TableCell, IconButton } from '@mui/material';
import { Iconic } from '@/commons/iconic';
import MenuPopover from '@/commons/menu-popover';
import { PropsTableRow } from './types';

export default function GeneralTableRow<T extends Record<string, unknown>>({
  row,
  selected,
  actions,
  onSelectRow,
  params,
  actionParamId,
}: PropsTableRow<T>) {
  const [openConfirm, setOpenConfirm] = useState(false);

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const splitRowToParam = (rowTemp: T, id: any): string => {
    const splitter = id.split('.');
    let value: any = splitter.shift();

    if (splitter.length > 0) {
      value = rowTemp[value];
      if (Array.isArray(value)) {
        value = value[0];
      }

      if (value) {
        splitter.forEach((valueId: string) => {
          if (typeof value[valueId] !== 'undefined') {
            value = value[valueId];
          }
        });
      }
      return value;
    }

    return row[value] as string;
  };

  return (
    <TableRow hover selected={selected}>
      {!!onSelectRow && (
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
      )}
      {params.slice(0, -1).map((item, index) => (
        <TableCell key={`${item.id}-${index}`} align={(item.align as any) || 'left'}>
          {item?.wrapComponent?.(splitRowToParam(row, item.id), row?.id ?? row?._id ?? '', row) ?? splitRowToParam(row, item.id)}
        </TableCell>
      ))}

      {actions && (
        <>
          <TableCell align="left">
            <IconButton color={openPopover ? 'primary' : 'default'} onClick={handleOpenPopover}>
              <Iconic icon="eva:more-vertical-fill" />
            </IconButton>
          </TableCell>

          <MenuPopover
            open={openPopover}
            onClose={handleClosePopover}
            arrow="right-top"
            sx={{ width: 'auto' }}
          >
            {actions({
              value: (row.id as unknown as string) || row._id,
              openConfirm,
              setOpenConfirm,
              setOpenPopover,
              data: row,
            })}
          </MenuPopover>
        </>
      )}
    </TableRow>
  );
}
